export default __webpack_public_path__ + "81d573a7e153e1f452d46d8d0df44957.riv";